@use 'sass:map';
@use 'sass:list';

@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/form';
@import '../../global/style/nano-theme/base';
@import '../../global/style/nano-theme/layers';

:host {
  /**
   * @prop --padding-top: Defaults to #{$spacing-small};
   * @prop --padding-bottom: Defaults to #{$spacing-small};
   * @prop --padding-start: Defaults to #{$spacing-small};
   * @prop --padding-end: Defaults to #{$spacing-small};

   * @prop --bg: default background. Defaults to none;
   * @prop --bg-selected: background when selected. Defaults to #{$select-opt-selected};
   * @prop --bg-focus: background when focused. Defaults to var(--nano-color-base, #{nano-color(primary, tint)});
   * @prop --bg-disabled: background when disabled. Defaults to none;

   * @prop --color: default text color. Defaults to var(--input-text-color, #{$input-text-color});
   * @prop --color-selected: text color when selected. Defaults to var(--nano-color-base, #{nano-color(primary, base)});
   * @prop --color-focus: text color when focused. Defaults to var(--nano-color-base, #{nano-color(primary, contrast)});
   * @prop --color-disabled: text color when disabled. Defaults to #{map.get($colors, palegrey)};

    * @prop --opt-icon-size: Sizes all icons within the option. Defaults to 1.4em;
  */

  --bg: none;
  --bg-selected: #{$select-opt-selected};
  --bg-focus: var(--nano-color-base, #{nano-color(primary, tint)});
  --bg-disabled: none;
  --color: var(--input-text-color, #{$input-text-color});
  --color-selected: var(--nano-color-base, #{nano-color(primary, base)});
  --color-focus: var(--nano-color-contrast, #{nano-color(primary, contrast)});
  --color-disabled: #{map.get($colors, palegrey)};
  --opt-icon-size: 1.6em;

  display: block;
  color: var(--color);
  overflow: hidden;
  font-size: 14px;
  font-size: #{'clamp(12px, .9em, 16px)'};
}

:host(:focus) {
  outline: none;
}

.option {
  $self: &;

  position: relative;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: stretch;
  width: 100%;
  background: var(--bg);
  padding-inline: var(--padding-start) var(--padding-end);
  padding-block: var(--padding-top) var(--padding-bottom);

  // focus
  :host(:focus) &:not(.option--disabled),
  :host &.option--selected {
    outline: none;
    background: var(--bg-selected);
    color: var(--color-selected);
  }

  :host(:focus) &:not(.option--disabled) {
    background: var(--bg-focus);
    color: var(--color-focus);
  }

  // disabled
  &.option--disabled {
    outline: none;
    color: var(--color-disabled);
    cursor: not-allowed;
    background: var(--bg-disabled);
  }

  // no value
  &.option--novalue {
    font-style: italic;
    opacity: 0.7;
  }

  &__label {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  &__start {
    flex: 0 0 auto;
    display: flex;
    align-items: center;

    ::slotted(nano-icon) {
      font-size: var(--opt-icon-size);
    }

    ::slotted(:last-child) {
      margin-inline-end: 0.5em;
    }
  }

  &__end {
    flex: 0 0 auto;
    display: flex;
    align-items: center;

    ::slotted(nano-icon) {
      font-size: var(--opt-icon-size);
    }

    ::slotted(:first-child) {
      margin-inline-start: 0.5em;
    }
  }

  &__check {
    visibility: hidden;
    display: flex;
    position: absolute;
    inset-inline-start: 0.6em;
    inset-block-start: calc(50% - 0.6em);
    align-items: center;
    font-size: 0.9em;

    #{$self}--selected:not(#{$self}--novalue) & {
      visibility: visible;
    }
  }
}
